module.exports = __webpack_public_path__ + "static/media/icon-phone.47e54a44.svg";